// ------------------------------------
// Slide
// ------------------------------------

// Variáveis
const $slide = $('#slide-lista');
let slideFixHeightFix;

slideInitSlick();

// Desabilita o plugin de carrosel
function slideDestroySlick() {
  if ($slide.hasClass('slick-slider')) {
    $slide.slick('unslick');
    $slide.removeClass('slick-loaded');
  }
}

// Inicializa o plugin
function slideInitSlick() {
  let speed = $slide.data('speed') * 1000;
  let dots = $slide.children().length > 1;
  //let slideAutoplay = previewMode !== true && (isMedia('xl') || isMedia('lg'));
  let slideAutoplay = previewMode !== true;
  $slide
    .on('init', function () {
      setTimeout(() => {
        $slide.addClass('slick-loaded');
        if (!previewMode) {
          AOS.refreshHard();
        }
      }, 100);
      const $firstImg = $slide.find('img').first();
      $firstImg.on('load', function () {
        //console.log($firstImg[0]);
        //$(window).trigger('resize');
        $slide[0].slick.refresh();
      });
      fixDividerPosition();
      if (slideFixHeightFix !== undefined) {
        clearInterval(slideFixHeightFix);
      }
      slideFixHeightFix = setInterval(() => {
        fixSlideHeight($slide);
      }, 500);
    })
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: dots,
      infinite: true,
      autoplay: slideAutoplay,
      autoplaySpeed: speed,
      adaptiveHeight: true,

      // Responsivo
      responsive: [
        // Mobile
        {
          breakpoint: 768,
          settings: {
            arrows: false,
          },
        },
      ],
    });
}

// Ajusta o posicionamento do divisor automaticamente
function fixDividerPosition() {
  const $dividerEl = $('#slide .section-divider:not(.d-none)');
  if ($dividerEl.length > 0) {
    const dividerHeight = $dividerEl.height();
    $dividerEl.css('margin-top', '-' + dividerHeight + 'px');
  }
}
$(window).on('resize orientationchange', fixDividerPosition);
$slide.on('change-divider', fixDividerPosition);

// Ajusta o slide corrigindo o problema de altura de 1px
function fixSlideHeight($slideEl) {
  if ($slideEl.length > 0) {
    const $slideList = $slideEl.find('.slick-list');
    if ($slideList.length > 0) {
      const slideHeight = $slideList.height();
      if (slideHeight < 10) {
        $slideEl[0].slick.refresh();
      } else {
        clearInterval(slideFixHeightFix);
      }
    }
  }
}

//slickReinitLazy($slide, slideInitSlick, slideDestroySlick);
